import { AsyncEncryptStorage, EncryptStorage } from 'encrypt-storage';

const localStorageSecret = process.env.REACT_APP_LOCAL_STORAGE_SECRET || 'cloud_smartcosmos'

export const reduxencryptStorage = new AsyncEncryptStorage(localStorageSecret, {stateManagementUse: true});

